export class WbInfiniteScroll {
  constructor() {
    this.className = '.wb-entry-cards';
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        `${this.className}__load-more`,
        _this.loadMoreProjects.bind(_this),
      );
  }

  loadMoreProjects(e) {
    const { relatedForm } = e?.target?.dataset;
    e?.target?.setAttribute('disabled', '');
    const { nextUrl } = document.querySelector(`${this.className}__list`)?.dataset;
    document.querySelector(`${this.className}__loading-list`)?.classList.remove('d-none');
    if (nextUrl) {
      const fetchObject = {};

      if (relatedForm && document.querySelector(`#${relatedForm}`)) {
        const formElement = document.querySelector(`#${relatedForm}`);
        const data = new URLSearchParams(new FormData(formElement));

        fetchObject.method = 'post';
        fetchObject.body = data;
        fetchObject.headers = {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        };
      }

      const fetching = fetch(nextUrl, fetchObject);
      fetching
        .then(response => response.text())
        .then(htmlResponse => this.replaceElement(htmlResponse))
        .catch(error => console.error('Error:', error));
    } else {
      document.querySelector(`${this.className}__loading-list`)?.classList.add('d-none');
    }
  }

  replaceElement(htmlResponse) {
    if (htmlResponse) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlResponse, 'text/html');
      const bodyElement = doc?.childNodes[0];
      if (bodyElement) {
        const childNode = bodyElement.nextSibling.querySelector(`${this.className}__list`);
        if (childNode) {
          const { nextUrl } = childNode.dataset;
          const currentProjectsListElement = document.querySelector(`${this.className}__list`);
          currentProjectsListElement.append(...childNode.childNodes);
          currentProjectsListElement.setAttribute('data-next-url', nextUrl);
          document.querySelector(`${this.className}__loading-list`)?.classList.add('d-none');
          document.querySelector(`${this.className}__load-more-btn`)?.removeAttribute('disabled');
          if (!nextUrl) {
            document.querySelector(`${this.className}__load-more`)?.classList.add('d-none');
          }
        }
      }
    }
  }
}
